import Vue from 'vue'
import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import util from '@/utils'

const state = {
  /** ==========START========== 试题浏览 ==========START========== */

  // -- start added by xieyan 20180211 --
  pageNo: 1,                        // 试题库中试题分页显示的页数
  pageSize: types.SCROLL_LOADING.EXERCISE_PAGE_SIZE,  // 试题库中试题分页显示每页件数
  maxNum: 0,                        // 试题库中试题分页显示最大件数
  scrollFlag: false,                // 防止滚动条多次加载，false时不加载 added by xieyan 20180212
  showTreeCheckBox:true,
  // -- end added by xieyan 20180211 --
  // -- start added by xieyan 20180216 --
  realExerciseTypes: [],            // 试题库中存在的试题类型
  defaultExerciseTypes: [
    {key: 1, value: "单选"},
    {key: 2, value: "多选"},
    {key: 3, value: "判断"},
    {key: 4, value: "填空"},
    {key: 5, value: "简答"},
    {key: 6, value: "综合"},
    {key: 8, value: "会计分录"},
    {key: 9, value: "凭证表格"},
  ],                                // 默认提供的试题种类
  exerciseNum4Auto: {},   // 自动创建试卷记录各题型数量的数组
  maxExerciseNumOfType: {},   // 页面查询的每种题型的最大数量
  exerciseType: "",                  // 当前选中的试题类型，默认全部
  exercisePracticeList: [],                 // 试题列表
  exerciseAutoNameList: [],                 // 试题列表
  exerciseArr4handle: [],           // 手工组卷保存试题的数组对象
  // -- end added by xieyan 20180216 --
  /** ===========END=========== 试题浏览 ===========END=========== */

  /** ==========START========== 添加编辑 ==========START========== */
  exercise: {},                     // 一道试题，添加/编辑
  knowledgeList: [],                // 知识点

  /** ----------- 表格 ---------- */
  cTableTemplate: {},                 // 当前编辑的表格模板
  basicTableTemplateList: [],        // 基础表格模板List
  etElement: {
    tableTemplateId: '',              // 试题表格id
    type: 1,                          // 元素样式
    css: '',                          // 试题表格id
    isShow: 0,                        // 是否显示给学生
    showContent: '',                  // 显示内容
    isScoreArea: 1,                   // 是否评分
    answer: ''                        // 正确答案
  },                                 // 添加表格题时,一张模板的所有空，接收模板elements(not use)
  cAccountingRecord:{},              // 当前编辑的会计分录子题
  /** ===========END=========== 添加编辑 ===========END=========== */
  // 印章List
  signList: [{
    id: "1",
    name: "现金付讫",
    pic: "/resources/files/signs/现金付讫.png",
    width: 94,
    height: 37}
  ],
  lineList:[]

}

const actions = {
  setExercise({commit}, exercise){
    commit('SET_EXERCISE', exercise);
  },
  //-- start modified by xieyan 20180217 --
  // 重置试题
  resetPracticeExercise({commit}, param){
    let new_exercise = {};
    if (typeof(param) != "undefied" && typeof(param.practiceId) != "undefied" && !util.isNull(param.practiceId)) {
      new_exercise.practiceId = param.practiceId;
      new_exercise.chapterName=param.chapterNmae;
      new_exercise.sectionExerciseId=param.sectionExerciseId;
      new_exercise.sectionNmae=param.sectionNmae;
    }
    // 题库ID
    new_exercise.id = "";
    // 章ID
    new_exercise.chapterId="";
    // 节ID
    new_exercise.sectionId="";
    //节名称
    // 试题类型
    // 如果添加试题-保存并新建按钮点击-试题类型 = 上次的试题试题类型
    if (param && param.autoName && param.autoName != '') {
      new_exercise.autoName = param.autoName;
    } else {
      new_exercise.autoName = state.exerciseType == "" ? state.exerciseAutoNameList[0].autoName : state.exerciseType;
    }
    //试题基础类型
    if(state.exerciseType == ""){
      new_exercise.baseType = state.exerciseAutoNameList[0].baseType
    }else{
      for(var i = 0; i<state.exerciseAutoNameList.length; i++){
        if(state.exerciseAutoNameList[i].autoName == state.exerciseType){
          new_exercise.baseType = state.exerciseAutoNameList[i].baseType
        }
      }
    }
    // 试题题目
    new_exercise.question = "";
    // 答案
    new_exercise.ask = "";
    // 试题选项列表（类型为判断的场合）
    if (new_exercise.baseType == types.EXERCISES_TYPE.judge) {
      new_exercise.tExercisesItemEntityList = [
        {content: "正确", sort: 1, isCorrect: 1, id: "1"},
        {content: "错误", sort: 2, isCorrect: 0, id: "0"}
      ];
      // 试题选项列表（类型为单选或者多选的场合）
    } else if (new_exercise.baseType == types.EXERCISES_TYPE.one || new_exercise.baseType == types.EXERCISES_TYPE.multi) {
      new_exercise.tExercisesItemEntityList = [
        {content: "", sort: 1, isCorrect: 0, id: util.generateUUID()},
        {content: "", sort: 2, isCorrect: 0, id: util.generateUUID()},
        {content: "", sort: 3, isCorrect: 0, id: util.generateUUID()},
        {content: "", sort: 4, isCorrect: 0, id: util.generateUUID()},
      ];
      // 表格题没有选项
    } else if (new_exercise.baseType == types.EXERCISES_TYPE.table) {
      new_exercise.tExercisesItemEntityList = []
    } else if (new_exercise.baseType == types.EXERCISES_TYPE.comprehensive){
      new_exercise.subExerciseList = [];
    }
    // 试题难易度
    new_exercise.facilityValue = 1;
    // 试题分值（默认1分）
    new_exercise.score = 1;
    // 判分类型(2平均，1严格)
    new_exercise.scoreType = "2";
    // 平均每空分值
    new_exercise.averScore = 1;
    // 知识点
    new_exercise.tExercisesKnowledgeEntityList = [];
    // 附件
    new_exercise.tExercisesPicEntityList = [];
    // 表格模板
    new_exercise.tExercisesTableTemplatePojoList = [];
    // 会计分录子题
    new_exercise.tAccountingRecordPojoList = [];
    // 解析
    new_exercise.analysis = "";
    commit('SET_EXERCISE', new_exercise);
  },

  //-- start modified by xieyan 20180217 --
  // 获取基础表格模板
  getBasicTableTemplate({commit}){
    http.getBasicTableTemplate().then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit(types.SET_BASIC_TABLE_TEMPLATE_LIST, res.data);
      }
    })
  },
  setCTableTemplate({commit}, cTableTemplate){
    commit(types.SET_CTABLE_TEMPLATE, cTableTemplate);
  },
  setCAccountingRecord({commit},cAccountingRecord){
    commit('SET_CACCOUNT_RECORD', cAccountingRecord);
  },
  setCAccountingRecords({commit},cAccountingRecords){
    commit('SET_CACCOUNT_RECORDS', cAccountingRecords);
  },
  // 上传表格附件
  getPathOfUploadFile(data){
    let param = data.param;
    let success = data.callback;
  },
  // 分页显示试题库中试题,param{practiceIds,type,name,isReload}
  getPracticeExercisesList({commit}, param){
    // 防止滚动条多次加载
    commit('SET_SCROLL_FLAG', false);

    if(!param.showTreeCheckBox){
      commit("SET_SHOW_TRUE", false);
    }
    // 如果重新加载的情况，清空
    if (param.isReload) {
      commit("SET_PAGE_NO", 1);
      commit("SET_MAX_NUM", 0);
      commit("CLEAR_EXERCISES_LIST");

      // 继续加载的情况
    } else {
      commit("SET_PAGE_NO", parseInt(state.pageNo) + 1);
    }

    // 查询条件作成
    let params = {
      practiceIds: param.practiceIds,
      autoName: state.exerciseType,
      sectionIds: param.sectionIds,
      //type: state.exerciseType,
      name: param.name,
      pageNo: state.pageNo,
      pageSize: state.pageSize,
    }
    // 查询
    http.GetPracticeExercisesList(params).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        // 试题List
        commit("SET_EXERCISES_LIST_PRACTICE", res.data.list);
        // 试题最大数量
        commit("SET_MAX_NUM", res.data.count);
        // 控制显示与否的变量
        commit("SET_SHOW_TRUE", true);
        if(res.data.list.length > 0){
          commit('setheaderthree', res.data.list[0].practiceName)
        }
      }
    });
    // 防止滚动条多次加载 added by xieyan 20180212
    setTimeout(() => {
      commit('SET_SCROLL_FLAG', true);
    }, types.SCROLL_LOADING.DELAY_TIME);
  },
  getAutoQuestionPracticeList({commit}, param){
    commit("RESET_AUTO_QUESTION_EXERCISES_LIST")
    let params = {
      courseId :param
    }
    http.selectAutoQuestionByPracticeCourseId(params).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        // 试题自定义名字List
        commit("SET_AUTO_QUESTION_EXERCISES_LIST", res.data);
        commit("SET_EXERCISE_NUM_4AUTO", res.data);
      }
    });
  },
  getStampList({commit},param){
    http.getStampList(param).then(res => {
      commit(types.SET_TOPIC_SIGN, res.data);
    })
  },
  getLineList({commit},param){
    http.getLineList(param).then(res => {
      commit(types.SET_LINE_LIST, res.data);
    })
  },
  // getChapterList({commit},param){
  //   http.getChapterList(param).then(res => {
  //     commit(types.SET_CHAPTER_LIST, res.data);
  //   })
  // },
  //-- start added by xieyan 20180216 --
  setExercisesList({commit}, param){
    commit("SET_EXERCISES_LIST_PRACTICE", param);
  },
  setPageNo({commit}, param){
    commit("SET_PAGE_NO", param);
  },
  setMaxNum({commit}, param){
    commit("SET_MAX_NUM", param);
  },
  setExerciseType({commit}, param){
    commit("SET_EXERCISE_TYPE", param);
  },

  clearExerciseArr4handle({commit}){
    commit('CLEAR_EXERCISE_ARR_4_HANDLE');
  },
  clearExerciseNum4Auto({commit}) {
    commit('CLEAR_EXERCISE_NUM_4_AUTO');
  },
  setScrollFlag({commit}, param) {
    commit('SET_SCROLL_FLAG', param);
  },
  clearKnowledgeList({commit},){
    commit(types.SET_KNOWLEDGELIST, []);
  },
  setKnowledgeList({commit}, param){
    commit(types.SET_KNOWLEDGELIST, param);
  },

  setShowTrue({commit},param){
    commit('SET_SHOW_TRUE',param);
  },

  setExerciseNum4autoItem({commit}, param){
    commit("SET_EXERCISE_NUM_4AUTO_ITEM", param);
  }
  //-- end added by xieyan 20180216 --
}

const getters = {}

const mutations = {
  // -- start added by xieyan 20180216 --
  ["SET_EXERCISES_LIST_PRACTICE"](state, param){
    for (let i = 0, j = param.length; i < j; i++) {
      state.exercisePracticeList.push(param[i]);
    }
  },
  ["SET_AUTO_QUESTION_EXERCISES_LIST"](state, param){
    for (let i = 0, j = param.length; i < j; i++) {
      state.exerciseAutoNameList.push(param[i]);
    }
  },
  ["SET_EXERCISE_NUM_4AUTO"](state, param){
    let maxExerciseNumOfType = {};
    let exerciseNum4Auto = {};
    for(var i=0; i<param.length; i++){
      maxExerciseNumOfType[param[i].autoName] = 0;
      exerciseNum4Auto[param[i].autoName] = 0;
    }
    Vue.set(state, 'maxExerciseNumOfType', maxExerciseNumOfType);//如果不添加这句话 maxExerciseNumOfType 只存在mv关系既数据到页面 添加后 为mvm数据绑定
    Vue.set(state, 'exerciseNum4Auto', exerciseNum4Auto); //如果不添加这句话 maxExerciseNumOfType 只存在mv关系既数据到页面 添加后 为mvm数据绑定
  },
  ["CLEAR_EXERCISES_LIST"](state){
    Vue.set(state, 'exercisePracticeList', new Array());
  },
  ["SET_PAGE_NO"](state, param){
    Vue.set(state, 'pageNo', param);
  },
  ["SET_PAGE_SIZE"](state, param){
    Vue.set(state, 'pageSize', param);
  },
  ["SET_MAX_NUM"](state, param){
    Vue.set(state, 'maxNum', param);
  },
  ["SET_EXERCISE_TYPE"](state, param){
    Vue.set(state, 'exerciseType', param);
  },

  ['CLEAR_EXERCISE_ARR_4_HANDLE'](state) {
    Vue.set(state, 'exerciseArr4handle', []);
  },
  ['CLEAR_EXERCISE_NUM_4_AUTO'](state) {
    for(var i in state.exercisePracticeList){
      state.exerciseNum4Auto[state.exercisePracticeList[i].autoName] = 0;
    }
  },
  ['SET_EXERCISE'](state, exercise) {
    Vue.set(state, 'exercise', exercise);
  },
  ['SET_SCROLL_FLAG'](state, scrollFlag) {
    Vue.set(state, 'scrollFlag', scrollFlag);
  },

  ['RESET_AUTO_QUESTION_EXERCISES_LIST'](state, param) {
    state.exerciseAutoNameList = [];
  },
  //-- end added by xieyan 20180216 --

  [types.SET_BASIC_TABLE_TEMPLATE_LIST](state, list){
    Vue.set(state, 'basicTableTemplateList', list);
  },
  [types.SET_CTABLE_TEMPLATE](state, cTableTemplate){
    Vue.set(state, 'cTableTemplate', cTableTemplate);
  },
  [types.SET_TOPIC_SIGN](state, signs){
    Vue.set(state, 'signList', signs);
  },
  [types.SET_LINE_LIST](state, lineList){
    Vue.set(state, 'lineList', lineList);
  },
  [types.SET_CHAPTER_LIST](state, chapterList){
    Vue.set(state, 'chapterList', chapterList);
  },
  [types.SET_KNOWLEDGELIST](state, list){
    Vue.set(state, 'knowledgeList', list);
  },
  ['SET_CACCOUNT_RECORD'](state,accountingRecord){
    Vue.set(state,'cAccountingRecord',accountingRecord)
  },
  ['SET_CACCOUNT_RECORDS'](state,accountingRecords){
    Vue.set(state,'cAccountingRecords',accountingRecords)
  },
  ['SET_SHOW_TRUE'](state, showTreeCheckBox) {
    Vue.set(state, 'showTreeCheckBox', showTreeCheckBox);
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/practiceView.js